import firebase from "firebase/app";
import { EventLocations } from "@/enums/EventLocations";
import {serializer} from "@/api/shared/serializer";
import {StaffAccessLevels} from "@/enums/StaffAccessLevels";
import {getRegionName} from "@/utils/functionsRegion";
import {eventBus} from "@/main";

export default {
  name: "WingsDigitalSignage",
  data() {
    return {
      loading: false,
      wings: [],
      facilities: [],
      digitalSignageIds: [],
      load: true
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
    user() {
      return this.$store.state.authModule.user;
    },
    digitalSignage() {
      return this.$store.state.digitalSignageModule.currentDigitalSignage;
    },
  },
  async created() {
    // TODO: change access levels
    if(this.user.accessLevel === StaffAccessLevels.OrgAdmin) {
      await this.getFacilitiesWings();
      await this.getFacilitiesDigitalSignage();
    } else {
      await this.getCurrentFacilityWings();
    }
    this.load = false;

    this.$emit('wings-updated', this.wings);
  },
  async mounted() {
    eventBus.$on('refreshWingsDigitalSignage', async () => {
      this.load = true;
      this.wings = []
      this.facilities = [];
      this.digitalSignageIds = [];

      setTimeout(async () => {
        if(this.user.accessLevel === StaffAccessLevels.OrgAdmin) {
          await this.getFacilitiesWings();
          await this.getFacilitiesDigitalSignage();
        } else {
          await this.getCurrentFacilityWings();
        }
        this.$emit('wings-updated', this.wings);
        this.load = false;
      }, 1000);
    })
  },
  beforeDestroy() {
    this.wings = [];
    this.facilities = [];
    this.digitalSignageIds = [];
  },
  methods: {
    async update() {
      this.loading = true;

      if(this.user.accessLevel === StaffAccessLevels.OrgAdmin) {
        await this.updateWingsDigitalSignage();
      } else {
        await this.updateWingsCurrentDigitalSignage();
      }

      await this.$store.dispatch("getDigitalSignage", this.$route.params.id);
      this.$emit('wings-updated', this.wings);

      this.loading = false;
    },
    selectAll(index) {
      const facilityWing = this.wings[index];
      if(facilityWing.isSelectAll) {
        facilityWing.selectedWings = facilityWing.allWings.map(wing => wing.id)
      } else {
        facilityWing.selectedWings = [];
      }
    },
    selectWing(index) {
      const facilityWing = this.wings[index];
      facilityWing.isSelectAll = facilityWing.selectedWings.length === facilityWing.allWings.length;
    },
    async getCurrentFacilityWings() {
      await firebase
        .firestore()
        .collection("eventLocations")
        .where("facilityId", "==", this.facilityId)
        .where("type", "==", EventLocations.Wing)
        .get()
        .then((querySnapshot) => {

          const wings = serializer.querySnapshotToDocuments(querySnapshot);
          const facilityWings = {
            facilityId: this.facilityId,
            facilityName: this.$store.state.authModule.currentFacilityData.name,
            digitalSignageId: this.digitalSignage.id,
            isSelectAll: true,
            allWings: [],
            selectedWings: []
          };

          if(Object.prototype.hasOwnProperty.call(this.digitalSignage, 'selectedWings')) {
            facilityWings.selectedWings = this.digitalSignage?.selectedWings ?? [];
            wings.forEach((wing: any) => {
              if(!this.digitalSignage?.selectedWings.length || (this.digitalSignage?.selectedWings.length && !this.digitalSignage?.selectedWings.find(x => x === wing.id))) {
                facilityWings.isSelectAll = false;
              }
              facilityWings.allWings.push({
                id: wing.id,
                name: wing.name
              })
            });
          } else {
            facilityWings.allWings = wings.map((wing: any) => {
              return {
                id: wing.id,
                name: wing.name
              }
            })
            facilityWings.selectedWings = wings.map(wing => wing.id)
          }

          this.wings.push(facilityWings);
        })
    },
    async getFacilitiesWings() {
      const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-getOrgDocuments')({
        orgId: this.$store.state.authModule.currentFacilityData.orgId,
        collectionName: 'eventLocations',
        conditions: [{property: 'type',condition:'==',value: EventLocations.Wing}]
      });
      const wings = [];

      await this.$store.dispatch("getFacilitiesForOrg");

      response.data.data.forEach((wing) => {
        const index = wings.findIndex(x => x.facilityId === wing.facilityId);
        if(index >= 0) {
          wings[index].allWings.push({
            id: wing.id,
            name: wing.name
          })
        } else {
          wings.push({
            facilityId: wing.facilityId,
            facilityName: this.$store.state.userModule.facilitiesForOrg.find(x => x.id === wing.facilityId).name,
            isSelectAll: true,
            allWings: [{
              id: wing.id,
              name: wing.name
            }],
            selectedWings: []
          })
        }
      });

      this.wings = wings.map((x) => {
        return {
          ...x,
          isSelectAll: x.selectedWings.length === x.allWings.length
        }
      });
    },
    async getFacilitiesDigitalSignage() {

      if(Object.prototype.hasOwnProperty.call(this.digitalSignage, 'parentDigitalSignageId')) {
        const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-getOrgDocuments')({
          orgId: this.$store.state.authModule.currentFacilityData.orgId,
          collectionName: 'digitalSignage',
          conditions: [{property: 'parentDigitalSignageId',condition:'==',value: this.digitalSignage.parentDigitalSignageId}]
        });

        if(!response.data.data.length) {
          this.wings = [];
          await this.getCurrentFacilityWings();

          return;
        }

        response.data.data.forEach(digitalSignage => {
          const currentWing = this.wings.find(x => x.facilityId === digitalSignage.facilityId);
          currentWing.digitalSignageId = digitalSignage.id;

          if(Object.prototype.hasOwnProperty.call(digitalSignage, 'selectedWings')) {
            currentWing.selectedWings = digitalSignage?.selectedWings ?? [];

            currentWing?.allWings.forEach(wing => {
              if(!digitalSignage?.selectedWings.length || (digitalSignage?.selectedWings.length && !digitalSignage?.selectedWings.find(x => x === wing.id))) {
                currentWing.isSelectAll = false;
              }
            })
          } else {
            currentWing.selectedWings = currentWing.allWings.map(wing => wing.id)
          }

          this.digitalSignageIds.push(digitalSignage.id)
          this.facilities.push(digitalSignage.facilityId);
        });
      } else {
        this.facilities.push(this.facilityId);

        this.wings.forEach((x) => {
          if(x.facilityId === this.facilityId) {
            x.digitalSignageId = this.digitalSignage.id;
            x.selectedWings = this.digitalSignage.selectedWings;
            x.isSelectAll = x.selectedWings.length >= x.allWings.length;
          }
        })
      }

      this.wings = this.wings.filter((x) => this.facilities.includes(x.facilityId))
    },
    async updateWingsCurrentDigitalSignage() {
      const selectedWings = this.wings.find(x => x.facilityId === this.facilityId).selectedWings;

      await firebase
        .firestore()
        .collection('digitalSignage')
        .doc(this.digitalSignage.id)
        .update({
          selectedWings: selectedWings
        }).then(() => {
          this.$toast.open({
            message: this.$i18n.messages[this.$i18n.locale]['WingsDigitalSignage.DigitalSignageHasBeenUpdated'],
            type: "success"
          });
        })
    },
    async updateWingsDigitalSignage() {
      for(let i = 0; i < this.wings.length; i++) {
        await firebase.app().functions(getRegionName()).httpsCallable('utils-updateOrgDocument')({
          orgId: this.$store.state.authModule.currentFacilityData.orgId,
          collectionName: 'digitalSignage',
          docId: this.wings[i].digitalSignageId,
          facilityId: this.wings[i].facilityId,
          updates: {
            selectedWings: this.wings[i].selectedWings
          }
        });
      }

      this.$toast.open({
        message: this.$i18n.messages[this.$i18n.locale]['WingsDigitalSignage.DigitalSignageHasBeenUpdated'],
        type: "success"
      });
    }
  }
}
